import { render, staticRenderFns } from "./filterSearch.vue?vue&type=template&id=481a70b1&scoped=true"
import script from "./filterSearch.vue?vue&type=script&lang=js"
export * from "./filterSearch.vue?vue&type=script&lang=js"
import style0 from "./filterSearch.vue?vue&type=style&index=0&id=481a70b1&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../../../../../../../opt/deploy_node_modules/ailaworld/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "481a70b1",
  null
  
)

export default component.exports